import {React, useState} from 'react';
import {Grid,Box, Button,Paper,Stack,Typography} from '@mui/material';
import {Add, ArrowForwardIos} from '@mui/icons-material';
import { HiReceiptTax } from "react-icons/hi";
import '../../App.css'
import EarningComponentsTable from '../table-data/EarningComponentsTable';
import Popup from '../Popup';
import ViewDeductionComponents from './ViewDeductionComponents';
import AddEmpEarningComponent from './AddEmpEarningComponent';

function ViewEarningComponents(props){

const [openPopup1, setOpenPopup1] = useState(false);
const [openPopup2, setOpenPopup2] = useState(false);

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault();
  }

  const handleCloseModal = () => {
    setOpenPopup1(false);
  };

  return(
    <Box sx={{display: "flex" ,justifyContent: "center",  marginTop: "-40px",margin: "10px", marginBottom: "10px", padding: "30px", fontWeight: "500px"}}>
      <Paper elevation={0}>
        <Grid className="form-title"  style={{marginBottom: "-50px", marginTop: "-60px"}} container spacing={2}>
          <Grid item> <Typography variant="h5" color="#344D67" sx={{textAlign: "center", textDecoration: "underline", margin: 5}}>Earning Components</Typography> </Grid>
          <Grid item> <HiReceiptTax style={{marginLeft: "-50px"}} size="30px" color="#344D67"/> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{margin: "30px"}}>

            <Stack display="flex" sx={{alignItems: "flex-end" }}>
                          <Button
                          style={{width: "200px"}}
                            className="form-btn"
                            variant="outlined"
                            color="success"
                            onClick={() => setOpenPopup1(true)}
                            startIcon={<Add sx={{ width: "24px", height: "24px" }} />} // Use a reasonable size here
                            sx={{
                              whiteSpace: "nowrap",
                              textTransform: "none"
                            }}
                          >
                            Add New Component
                          </Button>
                        </Stack>

            <EarningComponentsTable employeeID={props.employeeID} fetch_id={props.fetch_id}/>

            <Stack className="end-align" >
                    <Button className="form-btn" variant="outlined" onClick={() =>  setOpenPopup2(true)} endIcon={<ArrowForwardIos/>} >Next</Button>
            </Stack>

            </Stack>
        </form>

        <Popup
          title="Add"
          openPopup={openPopup1}
          setOpenPopup={setOpenPopup1}
        >
          <AddEmpEarningComponent title="Add New Earning Component" employeeID={props.employeeID} fetch_id={props.fetch_id} onCloseModal={handleCloseModal}/>
          {/*<AddEmployeeForm/>
          <EmployeeSalaryForm/>
          <LeaveDataMaster/>*/}
        </Popup>

        <Popup
          title="Earning Components"
          openPopup={openPopup2}
          setOpenPopup={setOpenPopup2}
        >

          <ViewDeductionComponents employeeID={props.employeeID} fetch_id={props.fetch_id} />

      </Popup>

      </Paper>
    </Box>
  )
}

export default ViewEarningComponents;
